// Support search helpers — error mapping + formatters.
// Ported from client/client/src/components/supportSearchHelpers.ts.

import { KeycastError } from '@/lib/keycastClient'

export const MIN_SEARCH_CHARS = 2
export const RESULT_CAP = 25

export function mapSearchError(err: unknown): string {
  if (err instanceof KeycastError) {
    if (err.status === 400) return 'Type at least 2 characters.'
    if (err.status === 403) return 'You don\u2019t have permission to search restaurants.'
  }
  return 'Search failed. Please try again.'
}

export function mapGrantError(err: unknown): string {
  if (err instanceof KeycastError) {
    if (err.status === 400) return 'Not fully provisioned \u2014 this restaurant has no stored key.'
    if (err.status === 403) return 'Permission denied.'
    if (err.status === 404) return 'Restaurant not found.'
  }
  return 'Something went wrong. Please try again.'
}

export function formatAdminEmails(emails: readonly string[]): string {
  if (emails.length === 0) return '(no admin email)'
  return emails.join(', ')
}
